import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Adresse } from 'src/app/models/models';


@Component({
  selector: 'app-adresses',
  templateUrl: './adresses.component.html',
  styleUrls: ['./adresses.component.scss']
})
export class AdressesComponent implements OnInit {

  bite : any ;
  private _adresses : Adresse[];
  public get adresses() : Adresse[] {
    return this._adresses;
  }
  public set adresses(v : Adresse[]) {
    this._adresses = v;
  }
  

  constructor(public sanitizer:DomSanitizer) { 
    this.adresses = [
      {nom: "Cabinet privé Andenne",rue: "Avenue Reine Elisabeth 103",codePost: "5300 Andenne",parking: "Parking facile devant l'entrée",tel: "tél : 085/84.51.28",fax : "fax :  085/84.62.13",mapUrl : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2538.3148001396394!2d5.0891725153664416!3d50.49109859231682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c1a6846fe33211%3A0x330626f082128168!2sAvenue%20Reine%20Elisabeth%20103%2C%205300%20Andenne!5e0!3m2!1sfr!2sbe!4v1604501347028!5m2!1sfr!2sbe",color : "rgba(169, 245, 187,0.8)",banc :"Oui"},
      {nom: "Cabinet médical Huy",rue: "Rue des Augustins 20",codePost: "4500 Huy",parking: "En face du Quadrilatère",tel: "tél : 085/84.51.28",fax : "fax : 085/84.62.13",mapUrl : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2536.7158487589486!2d5.239661415367556!3d50.52085369017112!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c1a99d68f62a79%3A0xa2b3296c347e2d75!2sRue%20des%20Augustins%2020%2C%204500%20Huy!5e0!3m2!1sfr!2sbe!4v1604501649796!5m2!1sfr!2sbe",color : "rgb(172, 232, 220)",banc :"Non"},
      {nom: "CHR Huy",rue: "Rue des trois ponts 2",codePost: "4500 Huy",parking: "Parking à proximité",tel: "tél : 085/27.74.60",fax : "fax :  085/27.74.69",mapUrl : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2537.1207361689967!2d5.237346115367294!3d50.51332029071447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c1a970e679f229%3A0xd162c75772e1926f!2sRue%20des%20Trois%20Ponts%202%2C%204500%20Huy!5e0!3m2!1sfr!2sbe!4v1604501774885!5m2!1sfr!2sbe" ,color : "rgba(46, 105, 93,0.6)",banc :"Oui"}
    ]
  }

  ngOnInit(): void {
    
  }

  

}
